module.exports = __webpack_public_path__ + "img/my.2dc93a83.svg";